import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import {
  AnalyticsUpIcon,
  ChampionIcon,
  Coins01Icon,
  InternetAntenna01Icon,
  Link06Icon,
  Medal02Icon,
  Medal03Icon,
  SignalNo01Icon,
  UserAccountIcon,
  UserGroupIcon,
  UserIcon,
  UserStatusIcon,
  UserStoryIcon,
  WifiLockIcon,
} from "hugeicons-react";
import { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { Counter } from "../../components/Stats/Counter";
import { find } from "../../services/service";
import { useStoreStats } from "../../store/StatsStore";
import { useGlobalStore } from "../../store/store";
import { useStoreCommune } from "../../store/storeCommune";
import {
  COURBE_VENTE_PAR_HEURE,
  LISTE_COMMUNE_SANS_PAGINATION,
  PERFORMANCE_PAR_COMMUNE,
  STATUS_BRIN_PAR_ZONE,
  TOP_10_AGENT,
  TOP_10_AGENT_MOINS_PERF,
  TOP_10_TECHNICIEN,
  TOP_10_TECHNICIEN_MOINS_PERF,
  TOTAL_CONNECTION,
} from "../../Utils/constant";
import { months } from "../../Utils/Utils";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  LineController,
  LineElement,
  PointElement,
);

export const Performance = () => {
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [select, setSelect] = useState("ANNEE");
  const [communeId, setCommuneId] = useState("");
  const [statsBrin, setStatsBrin] = useState({});
  const [topAgent, setTopAgent] = useState([]);
  const [topTechnicien, setTopTechnicien] = useState([]);
  const [topWorstAgent, setTopWorstAgent] = useState([]);
  const [topWorstTechnicien, setTopWorstTechnicien] = useState([]);
  const statsData = useStoreStats();
  const totalClient = useGlobalStore();
  const commune = useStoreCommune();
  const [grapheData, setGrapheData] = useState({
    data: {
      labels: months.map((item) => item.name),
      datasets: [
        {
          label: "Courbes d'évolution des ventes par heure sur la journée",
          data: [],
          backgroundColor: "#fbbf24",
          borderColor: "white",
          borderRadius: 3,
          borderSkipped: false,
        },
      ],
    },
    options: {
      responsive: true,
      plugins: {
        legend: {
          position: "top",
        },
        title: {
          display: true,
          text: "",
        },
      },
    },
  });

  useEffect(() => {
    statsData.getData(
      `${PERFORMANCE_PAR_COMMUNE}?communeId=&periode=&mois=&annee=&dateDebut=&dateFin=`,
    );
    find(`${STATUS_BRIN_PAR_ZONE}?communeId=`)
      .then((result) => {
        setStatsBrin(result?.data?.donnee);
      })
      .catch((err) => {});

    find(`${COURBE_VENTE_PAR_HEURE}?communeId=`)
      .then((res) => {
        setGrapheData((prev) => ({
          ...prev,
          data: {
            labels: res?.data?.donnee?.labels,
            datasets: [
              {
                label:
                  "Courbes d'évolution des ventes par heure sur la journée",
                data: res?.data?.donnee.data,
                backgroundColor: "#fbbf24",
                borderColor: "white",
                borderRadius: 3,
                borderSkipped: false,
              },
            ],
          },
        }));
      })
      .catch((err) => {});

    find(`${TOP_10_AGENT}?communeId=`)
      .then((result) => {
        setTopAgent(result?.data?.donnee);
      })
      .catch((err) => {});

    find(`${TOP_10_TECHNICIEN}?communeId=`)
      .then((result) => {
        setTopTechnicien(result?.data?.donnee);
      })
      .catch((err) => {});

    find(`${TOP_10_AGENT_MOINS_PERF}?communeId=`)
      .then((result) => {
        setTopWorstAgent(result?.data?.donnee);
      })
      .catch((err) => {});

    find(`${TOP_10_TECHNICIEN_MOINS_PERF}?communeId=`)
      .then((result) => {
        setTopWorstTechnicien(result?.data?.donnee);
      })
      .catch((err) => {});

    totalClient.getData(
      `${TOTAL_CONNECTION}?communeId=&periode=ANNEE&mois=&annee=${new Date().getFullYear()}&dateDebut=&dateFin=`,
    );
    commune.getCommunePrestataire(
      `${LISTE_COMMUNE_SANS_PAGINATION}?prestataireId=`,
    );
  }, []);

  return (
    <div className="mt-7">
      <div className="mb-8">
        <div className="ml-auto lg:flex lg:gap-3">
          {/* <select
            onChange={(e) => {
              setSelect(e.target.value);
            }}
            className="my-2 select"
          >
            <option>Periode</option>
            <option value="MOIS">Filtre par mois</option>
            <option value="ANNEE" selected>
              Filtre par années
            </option>
          </select> */}
          {/* {select === "MOIS" ? (
            <select
              onChange={(e) => {
                statsData.getData(
                  `${PERFORMANCE_PAR_COMMUNE}?communeId=${communeId}&periode=${select}&mois=${
                    e.target.value
                  }&annee=${new Date().getFullYear()}&dateDebut=&dateFin=`
                );
                totalClient.getData(
                  `${TOTAL_CONNECTION}?periode=${select}&mois=${
                    e.target.value
                  }&annee=${new Date().getFullYear()}&dateDebut=&dateFin=`
                );
              }}
              className="my-2 select"
            >
              <option disabled selected>
                mois
              </option>
              {months.map((item) => (
                <option value={item.code}>{item.name}</option>
              ))}
            </select>
          ) : select === "ANNEE" ? (
            <select
              onChange={(e) => {
                statsData.getData(
                  `${PERFORMANCE_PAR_COMMUNE}?communeId=${communeId}&periode=ANNEE&mois=&annee=${e.target.value}&dateDebut=&dateFin=`
                );
                totalClient.getData(
                  `${TOTAL_CONNECTION}?periode=ANNEE&mois=&annee=${e.target.value}&dateDebut=&dateFin=`
                );
              }}
              className="my-2 select "
            >
              <option disabled selected>
                années
              </option>
              {years.map((item) => (
                <option
                  value={item.name}
                  selected={
                    new Date().getFullYear() === Number(item.name)
                      ? true
                      : false
                  }
                >
                  {item.name}
                </option>
              ))}
            </select>
          ) : (
            <ReactDatePicker
              dateFormat="dd-MM-yyyy"
              selected={startDate}
              onChange={(update) => {
                if (update[1] != null) {
                  statsData.getData(
                    `${PERFORMANCE_PAR_COMMUNE}?communeId=${communeId}&periode=JOUR&mois=&annee=&&dateDebut=${update[0]
                      ?.toLocaleDateString()
                      .replace(/\//g, "-")}&dateFin=${update[1]
                      ?.toLocaleDateString()
                      .replace(/\//g, "-")}`
                  );
                  totalClient.getData(
                    `${TOTAL_CONNECTION}?periode=JOUR&&mois=&annee=&dateDebut=${update[0]
                      ?.toLocaleDateString()
                      .replace(/\//g, "-")}&dateFin=${update[1]
                      ?.toLocaleDateString()
                      .replace(/\//g, "-")}`
                  );
                }
                setDateRange(update);
              }}
              startDate={startDate}
              endDate={endDate}
              selectsRange
              className="text-xs font-normal cursor-pointer btn btn-sm hover:bg-gray-100 text-center h-8 my-2 w-52 rounded-md border border-input bg-gray-100 px-3 py-1 shadow-sm"
            />
          )} */}
          <select
            onChange={(e) => {
              setCommuneId(e.target.value);
              find(`${STATUS_BRIN_PAR_ZONE}?communeId=${e.target.value}`).then(
                (result) => {
                  setStatsBrin(result?.data?.donnee);
                },
              );
              find(
                `${COURBE_VENTE_PAR_HEURE}?communeId=${e.target.value}`,
              ).then((res) => {
                setGrapheData((prev) => ({
                  ...prev,
                  data: {
                    labels: res?.data?.donnee?.labels,
                    datasets: [
                      {
                        label:
                          "Courbes d'évolution des ventes par heure sur la journée",
                        data: res?.data?.donnee.data,
                        backgroundColor: "#fbbf24",
                        borderColor: "white",
                        borderRadius: 3,
                        borderSkipped: false,
                      },
                    ],
                  },
                }));
              });

              statsData.getData(
                `${PERFORMANCE_PAR_COMMUNE}?communeId=${
                  e.target.value
                }&periode=${select}&mois=&annee=${new Date().getFullYear()}&dateDebut=&dateFin=`,
              );
              totalClient.getData(
                `${TOTAL_CONNECTION}?communeId=${e.target.value}&periode=ANNEE&mois=&annee=${e.target.value}&dateDebut=&dateFin=`,
              );

              find(`${TOP_10_AGENT}?communeId=${e.target.value}`).then(
                (result) => {
                  setTopAgent(result?.data?.donnee);
                },
              );

              find(`${TOP_10_TECHNICIEN}?communeId=${e.target.value}`).then(
                (result) => {
                  setTopTechnicien(result?.data?.donnee);
                },
              );

              find(
                `${TOP_10_AGENT_MOINS_PERF}?communeId=${e.target.value}`,
              ).then((result) => {
                setTopWorstAgent(result?.data?.donnee);
              });

              find(
                `${TOP_10_TECHNICIEN_MOINS_PERF}?communeId=${e.target.value}`,
              ).then((result) => {
                setTopWorstTechnicien(result?.data?.donnee);
              });
            }}
            className="my-2 select"
          >
            <option value="">Selectionnez une commune</option>
            {commune?.communePrestataire?.map((item) => (
              <option value={item?.id}>{item?.designation}</option>
            ))}
          </select>
        </div>

        <div className="mt-4 grid md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-3">
          <Counter
            icon={<Coins01Icon className="text-amber-600" />}
            color={"bg-[#d8e2fc]"}
            label={"Montant total"}
            count={new Intl.NumberFormat("fr-FR", {
              style: "currency",
              currency: "XOF",
            }).format(
              statsData?.data?.statsVolumeVenteParCommune?.montantTotal ?? "0",
            )}
          />

          <Counter
            icon={<AnalyticsUpIcon className="text-amber-600" />}
            color={"bg-[#d8e2fc]"}
            label={"Volume de vente"}
            count={
              statsData?.data?.statsVolumeVenteParCommune?.totalPaiement ?? "0"
            }
          />
          <Counter
            icon={<UserGroupIcon className="text-amber-600" />}
            color={"bg-[#f9e0e1]"}
            label={"Clients connectés"}
            count={
              statsData?.data?.statsConnectionParCommune?.totalConnection ?? "0"
            }
          />

          <Counter
            icon={<UserAccountIcon className="text-amber-600" />}
            color={"bg-[#f9e0e1]"}
            label={"Intention enregistrée"}
            count={
              statsData?.data?.statsAbonnement?.stats?.totalAbonnement ?? "0"
            }
          />

          <Counter
            icon={<UserStatusIcon className="text-amber-600" />}
            color={"bg-[#d8e2fc]"}
            label={"Clients connectés dans le delais"}
            count={totalClient?.data?.totalConnectionDelai ?? "0"}
          />
          <Counter
            icon={<UserStoryIcon className="text-amber-600" />}
            color={"bg-[#f9e0e1]"}
            label={"Clients connectés hors delai"}
            count={totalClient?.data?.totalConnectionHorsDelai ?? "0"}
          />
        </div>

        <div className="mt-4">
          <p className="font-mtn">Statut des brins par zone</p>
          <div className="mt-4 grid md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-3">
            <Counter
              icon={<Link06Icon className="text-amber-600" />}
              label={"Brin connecté"}
              count={statsBrin?.brinsConnecter ?? "0"}
            />

            <Counter
              icon={<SignalNo01Icon className="text-amber-600" />}
              label={"Brin defectueux"}
              count={statsBrin?.brinsDefecteux ?? "0"}
            />

            <Counter
              icon={<InternetAntenna01Icon className="text-amber-600" />}
              label={"Brin libre"}
              count={statsBrin?.brinsLibre ?? "0"}
            />

            <Counter
              icon={<WifiLockIcon className="text-amber-600" />}
              label={"Brin reserver"}
              count={statsBrin?.brinsReserver ?? "0"}
            />
          </div>
        </div>

        <div className="mt-3">
          <p className="font-mtn">Stats Agents et Techniciens</p>

          <div className="mt-4 grid md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-3">
            <div className="shadow rounded-lg p-3">
              <p className="font-bold font-mtn text-sm mb-3">
                Best Performing commerciaux
              </p>
              {topAgent.length !== 0 ? (
                topAgent?.map((item, index) => (
                  <div
                    className={`my-3 border px-2 py-1 rounded-md ${
                      index === 0
                        ? "border border-amber-300"
                        : index === 2
                          ? "border-amber-700"
                          : ""
                    } `}
                  >
                    <div className="flex items-center justify-between">
                      <div className="text-xs flex items-center gap-2">
                        <p>{index + 1}.</p>
                        <div className="w-8 h-8 flex items-center justify-center rounded-full bg-neutral-100">
                          <UserIcon size={16} />
                        </div>
                        <p className="">{item?.nomPrenoms}</p>
                      </div>
                      <div className="flex items-center gap-2">
                        <p className="font-mtn text-sm font-semibold">
                          {item?.totalVente}
                        </p>
                        {index === 0 ? (
                          <ChampionIcon className="text-amber-400" size={18} />
                        ) : index === 1 ? (
                          <Medal02Icon className="text-neutral-500" size={18} />
                        ) : index === 2 ? (
                          <Medal03Icon className="text-amber-700" size={18} />
                        ) : null}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-xs h-40 flex items-center justify-center">
                  <p>Aucune donnée pour le moment</p>
                </div>
              )}
            </div>

            <div className="shadow rounded-lg p-3">
              <p className="font-bold font-mtn text-sm mb-3">
                Best Performing Techniciens
              </p>
              {topTechnicien.length !== 0 ? (
                topTechnicien?.map((item, index) => (
                  <div
                    className={`my-3 border px-2 py-1 rounded-md ${
                      index === 0
                        ? "border border-amber-300"
                        : index === 2
                          ? "border-amber-700"
                          : ""
                    } `}
                  >
                    <div className="flex items-center justify-between">
                      <div className="text-xs flex items-center gap-2">
                        <p>{index + 1}.</p>
                        <div className="w-8 h-8 flex items-center justify-center rounded-full bg-neutral-100">
                          <UserIcon size={16} />
                        </div>
                        <p className="">{item?.nomPrenoms}</p>
                      </div>
                      <div className="flex items-center gap-2">
                        <p className="font-mtn text-sm font-semibold">
                          {item?.totalVente}
                        </p>
                        {index === 0 ? (
                          <ChampionIcon className="text-amber-400" size={18} />
                        ) : index === 1 ? (
                          <Medal02Icon className="text-neutral-500" size={18} />
                        ) : index === 2 ? (
                          <Medal03Icon className="text-amber-700" size={18} />
                        ) : null}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-xs h-40 flex items-center justify-center">
                  <p>Aucune donnée pour le moment</p>
                </div>
              )}
            </div>

            <div className="shadow rounded-lg p-3">
              <p className="font-bold font-mtn text-sm mb-3">
                Worst Performing commerciaux
              </p>
              {topWorstAgent.length !== 0 ? (
                topWorstAgent?.map((item, index) => (
                  <div
                    className={`my-3 border px-2 py-1 rounded-md ${
                      index === 0
                        ? "border border-amber-300"
                        : index === 2
                          ? "border-amber-700"
                          : ""
                    } `}
                  >
                    <div className="flex items-center justify-between">
                      <div className="text-xs flex items-center gap-2">
                        <p>{index + 1}.</p>
                        <div className="w-8 h-8 flex items-center justify-center rounded-full bg-neutral-100">
                          <UserIcon size={16} />
                        </div>
                        <p className="">{item?.nomPrenoms}</p>
                      </div>
                      <div className="flex items-center gap-2">
                        <p className="font-mtn text-sm font-semibold">
                          {item?.totalVente}
                        </p>
                        {index === 0 ? (
                          <ChampionIcon className="text-amber-400" size={18} />
                        ) : index === 1 ? (
                          <Medal02Icon className="text-neutral-500" size={18} />
                        ) : index === 2 ? (
                          <Medal03Icon className="text-amber-700" size={18} />
                        ) : null}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-xs h-40 flex items-center justify-center">
                  <p>Aucune donnée pour le moment</p>
                </div>
              )}
            </div>

            <div className="shadow rounded-lg p-3">
              <p className="font-bold font-mtn text-sm mb-3">
                Worst Performing Techniciens
              </p>
              {topWorstTechnicien.length !== 0 ? (
                topWorstTechnicien?.map((item, index) => (
                  <div
                    className={`my-3 border px-2 py-1 rounded-md ${
                      index === 0
                        ? "border border-amber-300"
                        : index === 2
                          ? "border-amber-700"
                          : ""
                    } `}
                  >
                    <div className="flex items-center justify-between">
                      <div className="text-xs flex items-center gap-2">
                        <p>{index + 1}.</p>
                        <div className="w-8 h-8 flex items-center justify-center rounded-full bg-neutral-100">
                          <UserIcon size={16} />
                        </div>
                        <p className="">{item?.nomPrenoms}</p>
                      </div>
                      <div className="flex items-center gap-2">
                        <p className="font-mtn text-sm font-semibold">
                          {item?.totalVente}
                        </p>
                        {index === 0 ? (
                          <ChampionIcon className="text-amber-400" size={18} />
                        ) : index === 1 ? (
                          <Medal02Icon className="text-neutral-500" size={18} />
                        ) : index === 2 ? (
                          <Medal03Icon className="text-amber-700" size={18} />
                        ) : null}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-xs h-40 flex items-center justify-center">
                  <p>Aucune donnée pour le moment</p>
                </div>
              )}
            </div>
          </div>
        </div>

        <div>
          <div className="mt-2 p-4 bg-white border rounded-lg shadow-sm">
            <h1 className="text-md font-semibold">
              Courbes d’évolution des ventes par heure sur la journée
            </h1>
            <Line
              className="mt-4"
              height={100}
              options={grapheData.options}
              data={grapheData.data}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
